export const PROCESS_ATTRIBUTE_TAG = "process_attribute";
export const PROCESS_ATTRIBUTE_LABEL = "Process attributes";
export const STEP_GROUP_ATTRIBUTE_TAG = "step_group_attributes";
export const STEP_GROUP_ATTRIBUTE_LABEL = "Swimlanes attributes";
export const STEP_ATTRIBUTE_TAG = "step_attributes";
export const STEP_ATTRIBUTE_LABEL = "Step attributes";
